import { defineComponent as _defineComponent } from 'vue';
import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx } from "vue";
const _hoisted_1 = ["value"];
const _hoisted_2 = ["id", "aria-controls", "aria-expanded", "aria-activedescendant", "aria-labelledby"];
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = ["id", "aria-labelledby"];
const _hoisted_5 = ["id", "aria-selected", "onClick"];
const _hoisted_6 = {
    key: 1,
    class: "selectCustom-option-prepend"
};
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = {
    key: 2,
    class: "selectCustom-option-append"
};
import { onBeforeUnmount, ref, reactive, computed } from 'vue';
import ThemeIcon from '../../shared/Icon/Icon.vue';
const __default__ = {
    inheritAttrs: false,
};
export default /*@__PURE__*/ _defineComponent(Object.assign(Object.assign({}, __default__), { __name: 'InputSelectCustom', props: {
        options: {},
        name: {},
        placeholder: {},
        modelValue: {}
    }, emits: ['update:modelValue'], setup(__props, { emit: __emit }) {
        let SelectAction;
        (function (SelectAction) {
            SelectAction[SelectAction["Close"] = 0] = "Close";
            SelectAction[SelectAction["CloseSelect"] = 1] = "CloseSelect";
            SelectAction[SelectAction["First"] = 2] = "First";
            SelectAction[SelectAction["Last"] = 3] = "Last";
            SelectAction[SelectAction["Next"] = 4] = "Next";
            SelectAction[SelectAction["Open"] = 5] = "Open";
            SelectAction[SelectAction["PageDown"] = 6] = "PageDown";
            SelectAction[SelectAction["PageUp"] = 7] = "PageUp";
            SelectAction[SelectAction["Previous"] = 8] = "Previous";
            SelectAction[SelectAction["Select"] = 9] = "Select";
            SelectAction[SelectAction["Type"] = 10] = "Type";
        })(SelectAction || (SelectAction = {}));
        const props = __props;
        const state = reactive({
            activeIndex: 0,
            isOpen: false,
            searchString: '',
            searchTimeout: 0,
        });
        const emit = __emit;
        const activeOption = computed(() => { var _a; return (_a = options.value) === null || _a === void 0 ? void 0 : _a.find((c) => c.key === props.modelValue); });
        const options = computed(() => { var _a; return ((_a = props.options) === null || _a === void 0 ? void 0 : _a.length) ? props.options : []; });
        const instanceId = Math.random().toString(36).substring(2, 12);
        const comboRootEl = ref();
        const comboEl = ref();
        const listboxEl = ref();
        let ignoreBlur = false;
        onBeforeUnmount(() => {
            if (state.searchTimeout) {
                window.clearTimeout(state.searchTimeout);
            }
        });
        function getHtmlId(key = '') {
            return `cselect-${instanceId}${key ? `-${key}` : ''}`;
        }
        function getPlaceholderChoice() {
            if (props.placeholder) {
                if (typeof props.placeholder === 'string') {
                    return {
                        key: '',
                        label: props.placeholder,
                    };
                }
                return props.placeholder;
            }
            return {
                key: '',
                label: 'Select...',
            };
        }
        function updateValue(index) {
            const option = options.value[index];
            emit('update:modelValue', option ? (option.hasOwnProperty('value') ? option.value : option.key) : null);
        }
        function jsonValue() {
            return JSON.stringify(props.modelValue);
        }
        function getSearchString(char) {
            // reset typing timeout and start new timeout
            // this allows us to make multiple-letter matches, like a native select
            if (state.searchTimeout) {
                window.clearTimeout(state.searchTimeout);
            }
            state.searchTimeout = window.setTimeout(() => {
                state.searchString = '';
            }, 500);
            // add most recent letter to saved search string
            state.searchString += char;
            return state.searchString;
        }
        function onComboBlur() {
            // do not do blur action if ignoreBlur flag has been set
            if (ignoreBlur) {
                ignoreBlur = false;
                return;
            }
            if (state.isOpen) {
                updateMenuState({ open: false });
            }
        }
        function onComboClick() {
            updateMenuState({ open: !state.isOpen });
        }
        function onComboKeyDown(event) {
            const { key } = event;
            const max = options.value.length - 1;
            const action = getActionFromKey(event, state.isOpen);
            if (!options.value.length) {
                return;
            }
            switch (action) {
                case SelectAction.Last:
                case SelectAction.First:
                    updateMenuState({ open: true });
                // intentional fallthrough
                case SelectAction.Next:
                case SelectAction.Previous:
                case SelectAction.PageUp:
                case SelectAction.PageDown:
                    event.preventDefault();
                    const updatedIndex = getUpdatedIndex(state.activeIndex, max, action);
                    return onOptionChange(updatedIndex, options.value[updatedIndex]);
                case SelectAction.CloseSelect:
                    event.preventDefault();
                    updateValue(state.activeIndex);
                // intentional fallthrough
                case SelectAction.Close:
                    event.preventDefault();
                    return updateMenuState({ open: false });
                case SelectAction.Type:
                    return onComboType(key);
                case SelectAction.Open:
                    event.preventDefault();
                    return updateMenuState({ open: true });
            }
        }
        function onComboType(letter) {
            // open the listbox if it is closed
            updateMenuState({ open: true });
            // find the index of the first matching option
            const searchString = getSearchString(letter);
            const searchIndex = getIndexByLetter((props === null || props === void 0 ? void 0 : props.options) || [], searchString, state.activeIndex + 1);
            // if a match was found, go to it
            if (searchIndex >= 0 && options.value.length) {
                onOptionChange(searchIndex, options.value[searchIndex]);
            }
            // if no matches, clear the timeout and search string
            else {
                window.clearTimeout(state.searchTimeout);
                state.searchString = '';
            }
        }
        function onOptionChange(index, option) {
            var _a;
            // update state
            state.activeIndex = index;
            const optionsEls = (_a = comboRootEl.value) === null || _a === void 0 ? void 0 : _a.querySelectorAll('[role=option]');
            // ensure the new option is in view
            if (isScrollable(listboxEl.value)) {
                maintainScrollVisibility(optionsEls[index], listboxEl.value);
            }
            // ensure the new option is visible on screen
            // ensure the new option is in view
            if (!isElementInView(optionsEls[index])) {
                optionsEls[index].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
        }
        function onOptionClick(index, option) {
            if (option) {
                onOptionChange(index, option);
                updateValue(index);
                updateMenuState({ open: false });
            }
        }
        function onOptionMouseDown() {
            ignoreBlur = true;
        }
        function updateMenuState(args) {
            var _a, _b;
            if (state.isOpen === args.open) {
                return;
            }
            // update state
            state.isOpen = args.open;
            const activeID = args.open ? getHtmlId(`option-${state.activeIndex}`) : '';
            if (!activeID && !isElementInView(comboEl.value)) {
                (_a = comboEl.value) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
            // move focus back to the combobox, if needed
            args.focus && ((_b = comboEl.value) === null || _b === void 0 ? void 0 : _b.focus());
        }
        /*
         * Helper functions
         */
        // filter an array of options against an input string
        // returns an array of options that begin with the filter string, case-independent
        function filterOptions(options = [], inputString, exclude = []) {
            return options.filter(option => {
                const matches = option.label.indexOf(inputString.toLowerCase()) === 0;
                return matches && exclude.findIndex(opt => opt.key !== option.key) < 0;
            });
        }
        // map a key press to an action
        function getActionFromKey(event, menuOpen) {
            const { key, altKey, ctrlKey, metaKey } = event;
            const openKeys = ['ArrowDown', 'ArrowUp', 'Enter', ' ']; // all keys that will do the default open action
            // handle opening when closed
            if (!menuOpen && openKeys.includes(key)) {
                return SelectAction.Open;
            }
            // home and end move the selected option when open or closed
            if (key === 'Home') {
                return SelectAction.First;
            }
            if (key === 'End') {
                return SelectAction.Last;
            }
            // handle typing characters when open or closed
            if (key === 'Backspace' ||
                key === 'Clear' ||
                (key.length === 1 && key !== ' ' && !altKey && !ctrlKey && !metaKey)) {
                return SelectAction.Type;
            }
            // handle keys when open
            if (menuOpen) {
                if (key === 'ArrowUp' && altKey) {
                    return SelectAction.CloseSelect;
                }
                else if (key === 'ArrowDown' && !altKey) {
                    return SelectAction.Next;
                }
                else if (key === 'ArrowUp') {
                    return SelectAction.Previous;
                }
                else if (key === 'PageUp') {
                    return SelectAction.PageUp;
                }
                else if (key === 'PageDown') {
                    return SelectAction.PageDown;
                }
                else if (key === 'Escape') {
                    return SelectAction.Close;
                }
                else if (key === 'Enter' || key === ' ') {
                    return SelectAction.CloseSelect;
                }
            }
        }
        // return the index of an option from an array of options, based on a search string
        // if the filter is multiple iterations of the same letter (e.g "aaa"), then cycle through first-letter matches
        function getIndexByLetter(options, searchString, startIndex = 0) {
            const orderedOptions = [
                ...options.slice(startIndex),
                ...options.slice(0, startIndex),
            ];
            const firstMatch = filterOptions(orderedOptions, searchString)[0];
            const allSameLetter = (letters) => letters.every(letter => letter === letters[0]);
            // first check if there is an exact match for the typed string
            if (firstMatch) {
                return options.indexOf(firstMatch);
            }
            else if (allSameLetter(searchString.split(''))) {
                // if the same letter is being repeated, cycle through first-letter matches
                const matches = filterOptions(orderedOptions, searchString[0]);
                return options.indexOf(matches[0]);
            }
            else {
                // if no matches, return -1
                return -1;
            }
        }
        // get an updated option index after performing an action
        function getUpdatedIndex(currentIndex, maxIndex, action) {
            const pageSize = 10; // used for pageup/pagedown
            switch (action) {
                case SelectAction.First:
                    return 0;
                case SelectAction.Last:
                    return maxIndex;
                case SelectAction.Previous:
                    return Math.max(0, currentIndex - 1);
                case SelectAction.Next:
                    return Math.min(maxIndex, currentIndex + 1);
                case SelectAction.PageUp:
                    return Math.max(0, currentIndex - pageSize);
                case SelectAction.PageDown:
                    return Math.min(maxIndex, currentIndex + pageSize);
                default:
                    return currentIndex;
            }
        }
        // check if element is visible in browser view port
        function isElementInView(element) {
            const bounding = element.getBoundingClientRect();
            return (bounding.top >= 0 &&
                bounding.left >= 0 &&
                bounding.bottom <=
                    (window.innerHeight || document.documentElement.clientHeight) &&
                bounding.right <=
                    (window.innerWidth || document.documentElement.clientWidth));
        }
        // check if an element is currently scrollable
        function isScrollable(element) {
            return element && element.clientHeight < element.scrollHeight;
        }
        // ensure a given child element is within the parent's visible scroll area
        // if the child is not visible, scroll the parent
        function maintainScrollVisibility(activeElement, scrollParent) {
            const { offsetHeight, offsetTop } = activeElement;
            const { offsetHeight: parentOffsetHeight, scrollTop } = scrollParent;
            const isAbove = offsetTop < scrollTop;
            const isBelow = offsetTop + offsetHeight > scrollTop + parentOffsetHeight;
            if (isAbove) {
                scrollParent.scrollTo(0, offsetTop);
            }
            else if (isBelow) {
                scrollParent.scrollTo(0, offsetTop - parentOffsetHeight + offsetHeight);
            }
        }
        return (_ctx, _cache) => {
            var _a;
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["selectCustom formInputUI", { 'is--open': state.isOpen }]),
                ref_key: "comboRootEl",
                ref: comboRootEl
            }, [
                _createElementVNode("input", _mergeProps(_ctx.$attrs, {
                    type: "hidden",
                    value: jsonValue()
                }), null, 16, _hoisted_1),
                _createElementVNode("div", {
                    id: getHtmlId(),
                    class: "selectCustom-input",
                    role: "combobox",
                    "aria-controls": getHtmlId('listbox'),
                    "aria-haspopup": "listbox",
                    "aria-expanded": state.isOpen,
                    "aria-activedescendant": state.isOpen ? getHtmlId(`option-${state.activeIndex}`) : '',
                    "aria-labelledby": getHtmlId('label'),
                    tabindex: "0",
                    ref_key: "comboEl",
                    ref: comboEl,
                    onBlur: onComboBlur,
                    onClick: onComboClick,
                    onKeydown: onComboKeyDown
                }, [
                    _createElementVNode("span", {
                        innerHTML: ((_a = activeOption.value) === null || _a === void 0 ? void 0 : _a.label) || getPlaceholderChoice().label,
                        class: "selectCustom-label"
                    }, null, 8, _hoisted_3),
                    _createVNode(ThemeIcon, {
                        class: "selectCustom-arrow",
                        name: "chevron-down"
                    })
                ], 40, _hoisted_2),
                _createVNode(_Transition, { name: "listbox" }, {
                    default: _withCtx(() => [
                        _withDirectives(_createElementVNode("div", {
                            id: getHtmlId('listbox'),
                            class: "selectCustom-menu",
                            role: "listbox",
                            "aria-labelledby": getHtmlId('-label'),
                            tabindex: "-1",
                            ref_key: "listboxEl",
                            ref: listboxEl
                        }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((options.value || []), (option, index) => {
                                var _a, _b;
                                return (_openBlock(), _createElementBlock("div", {
                                    key: option.key,
                                    id: getHtmlId(`option-${index}`),
                                    class: _normalizeClass(["selectCustom-option", {
                                            'is--selected': option.key === ((_a = activeOption.value) === null || _a === void 0 ? void 0 : _a.key),
                                            'is--highlighted': index === state.activeIndex,
                                        }]),
                                    role: "option",
                                    "aria-selected": option.key === ((_b = activeOption.value) === null || _b === void 0 ? void 0 : _b.key),
                                    onClick: _withModifiers(($event) => (onOptionClick(index, option)), ["stop"]),
                                    onMousedown: onOptionMouseDown
                                }, [
                                    (option.prependIcon)
                                        ? (_openBlock(), _createBlock(ThemeIcon, {
                                            key: 0,
                                            name: option.prependIcon
                                        }, null, 8, ["name"]))
                                        : _createCommentVNode("", true),
                                    (option.prepend)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(option.prepend), 1))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("span", {
                                        innerHTML: option.label
                                    }, null, 8, _hoisted_7),
                                    (option.append)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(option.append), 1))
                                        : _createCommentVNode("", true),
                                    (option.appendIcon)
                                        ? (_openBlock(), _createBlock(ThemeIcon, {
                                            key: 3,
                                            name: option.appendIcon
                                        }, null, 8, ["name"]))
                                        : _createCommentVNode("", true)
                                ], 42, _hoisted_5));
                            }), 128))
                        ], 8, _hoisted_4), [
                            [_vShow, state.isOpen]
                        ])
                    ]),
                    _: 1
                })
            ], 2));
        };
    } }));
